'use client';

import React from 'react';

import { useAppBadgesMethods } from './useAppBadgesMethods';

import { ExtendedLink } from '@/components/ExtendedLink';
import { DeviceType } from '@/modules/device/types';
import { useUserAgent } from '@/modules/device/useUserAgent';
import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';

type Props = {
  className?: string;
  hideBadge?: 'ios' | 'android';
  trackingId: string;
  showBoth?: boolean;
  directStoreLinks?: boolean;
};

export function AppBadges({
  className,
  hideBadge,
  trackingId,
  showBoth = false,
  directStoreLinks = false,
}: Props) {
  const { getIosAppBadge, getAndroidAppBadge, handleBadgeClick } =
    useAppBadgesMethods(directStoreLinks);

  const { device } = useUserAgent();
  const { language } = useCurrentLanguage();

  const showAndroidBadge =
    hideBadge !== 'android' &&
    (showBoth ||
      device === DeviceType.ANDROID ||
      device === DeviceType.GENERAL);

  const showIosBadge =
    hideBadge !== 'ios' &&
    (showBoth || device === DeviceType.IOS || device === DeviceType.GENERAL);

  const iosBadge = getIosAppBadge();
  const androidBadge = getAndroidAppBadge();

  return (
    <div className={className}>
      {showIosBadge && (
        <ExtendedLink
          // eslint-disable-next-line no-restricted-syntax
          data-testid={`badge__app--${language}`}
          href={iosBadge.href}
          onClick={() => handleBadgeClick(DeviceType.IOS, trackingId)}
        >
          {iosBadge.badge}
        </ExtendedLink>
      )}
      {showAndroidBadge && (
        <ExtendedLink
          // eslint-disable-next-line no-restricted-syntax
          data-testid={`badge__play--${language}`}
          href={androidBadge.href}
          onClick={() => handleBadgeClick(DeviceType.ANDROID, trackingId)}
        >
          {androidBadge.badge}
        </ExtendedLink>
      )}
    </div>
  );
}
